import { Sprite3D } from "../../../../d3/core/Sprite3D";
import { Vector2 } from "../../../../maths/Vector2";
import { WebBaseRenderNode } from "./WebBaseRenderNode";
var CLS = null;
export function WebMeshRenderNode() {
    if (!CLS)
        CLS = class extends WebBaseRenderNode.BaseRenderNodeClass {
            constructor() {
                super();
                this._cacheMoved = new Vector2(-1, -1);
                this.set_renderUpdatePreCall(this, this._renderUpdate);
            }
            _renderUpdate(context) {
                if (context.sceneModuleData.lightmapDirtyFlag != this.lightmapDirtyFlag) {
                    this._applyLightMapParams();
                    this.lightmapDirtyFlag = context.sceneModuleData.lightmapDirtyFlag;
                }
                this._applyReflection();
                this._applyLightProb();
                if (this.ismoved.x > this._cacheMoved.x || (this.ismoved.x == this._cacheMoved.x && this.ismoved.y > this._cacheMoved.y)) {
                    let trans = this.transform;
                    this.shaderData.setMatrix4x4(Sprite3D.WORLDMATRIX, trans.worldMatrix);
                    this._worldParams.x = trans.getFrontFaceValue();
                    this.shaderData.setVector(Sprite3D.WORLDINVERTFRONT, this._worldParams);
                    this.ismoved.cloneTo(this._cacheMoved);
                }
            }
        };
    return CLS;
}
